import React from 'react';
import SiteDown from 'components/pages/site-down';
import { trackEvent } from 'lib/analytics';
import { trackCustomError } from 'lib/datadog-rum';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  appProps?: any;
  // Change this to clear a tripped boundary — pass the current route so a
  // client-side navigation away from a broken page recovers without a reload.
  resetKey?: string;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(_error: Error): ErrorBoundaryState {
    return { hasError: true };
  }
  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { appProps } = this.props;
    trackEvent('Site Down', {
      page: appProps?.router?.pathname || 'unknown',
      message: error,
      errorInfo: JSON.stringify(errorInfo),
    });

    // Track error with Datadog
    trackCustomError(error, {
      source: 'error_boundary',
      page: appProps?.router?.pathname || 'unknown',
      componentStack: errorInfo.componentStack,
      errorBoundary: true,
    });
  }
  render() {
    if (this.state.hasError) {
      return <SiteDown />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
